import { useEffect, useState } from "react"

import { TextInputField } from "~/pages/Admin/components/Fields/TextInputField"
import { FormFieldConfig } from "~/pages/Admin/components/form.types"
import { ManualCheckIcon } from "~/pages/Brand/Certificates/components/ManualCheckIcon"
import { errorCodes } from "~/pages/SupplierPortal/TraceabilityRequests/components/ZodCustomErrorMap"

type useCertificateReferenceIconProps = {
  typeName: string
  certificateName: string | null
  reference: string | null
}

export function useCertificateReferenceIcon({
  typeName,
  certificateName,
  reference,
}: useCertificateReferenceIconProps) {
  const [icon, setIcon] = useState<React.ReactNode>(null)

  useEffect(() => {
    if (
      (typeName.toLowerCase().includes("oeko-tex") ||
        certificateName?.toLowerCase().includes("oeko-tex")) &&
      reference
    ) {
      setIcon(<ManualCheckIcon reference={reference} />)
    } else {
      setIcon(null)
    }
  }, [typeName, certificateName, reference])

  return icon
}

export const ReferenceInputField = (
  fields: FormFieldConfig,
  form: any,
  error: keyof errorCodes | undefined,
  translations: errorCodes | undefined
) => {
  const formValues = form.getValues()

  const icon = useCertificateReferenceIcon({
    typeName: formValues.type?.name,
    certificateName: formValues.name,
    reference: formValues.reference,
  })

  return TextInputField(fields, form, error, translations, {
    rightSection: icon,
  })
}
